/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} YouremailcomInputs */

const en_youremailcom = /** @type {(inputs: YouremailcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`your@email.com`)
};

const es_youremailcom = /** @type {(inputs: YouremailcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu@email.com`)
};

const fr_youremailcom = /** @type {(inputs: YouremailcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`votre@email.com`)
};

const de_youremailcom = /** @type {(inputs: YouremailcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deine@email.com`)
};

const ja_youremailcom = /** @type {(inputs: YouremailcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`your@email.com`)
};

const zh_youremailcom = /** @type {(inputs: YouremailcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`your@email.com`)
};

const ar_youremailcom = /** @type {(inputs: YouremailcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`your@email.com`)
};

const id_youremailcom = /** @type {(inputs: YouremailcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`email@anda.com`)
};

const it_youremailcom = /** @type {(inputs: YouremailcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu@email.com`)
};

const ru_youremailcom = /** @type {(inputs: YouremailcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`your@email.com`)
};

const pt_youremailcom = /** @type {(inputs: YouremailcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seu@email.com`)
};

const ko_youremailcom = /** @type {(inputs: YouremailcomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`your@email.com`)
};

/**
* | output |
* | --- |
* | "your@email.com" |
*
* @param {YouremailcomInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const youremailcom = /** @type {((inputs?: YouremailcomInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<YouremailcomInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youremailcom(inputs)
	if (locale === "es") return es_youremailcom(inputs)
	if (locale === "fr") return fr_youremailcom(inputs)
	if (locale === "de") return de_youremailcom(inputs)
	if (locale === "ja") return ja_youremailcom(inputs)
	if (locale === "zh") return zh_youremailcom(inputs)
	if (locale === "ar") return ar_youremailcom(inputs)
	if (locale === "id") return id_youremailcom(inputs)
	if (locale === "it") return it_youremailcom(inputs)
	if (locale === "ru") return ru_youremailcom(inputs)
	if (locale === "pt") return pt_youremailcom(inputs)
	return ko_youremailcom(inputs)
});